import toastr from "toastr";
import file from "../views/dedicated/components/pspDataComponents/file";

const Mixin = {
    methods: {
        checkIfIsPersian(value) {
            if (!value || value == 'null') return true;

            let regex = /^[\u0600-\u06FF\s]+$/;

            return regex.test(value)
        },
        checkIfIsEnglish(value) {
            if (!value || value == 'null') return true;

            let regex = /^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%\^&*| ']*$/;

            return regex.test(value)
        },
        checkValidatePhone(string) {
            if (!string || string == 'null') return true;
            let regex = /09\d{9}$/;

            return regex.test(string)
        },
        // convert persian digits to english
        toEng(str) {
            let
                persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
                arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
            if (typeof str === 'string') {
                for (var i = 0; i < 10; i++) {
                    str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
                }
            }
            return str;
        },
        formatLess(price) {
            if (price == null || price === '' || price === 0) {
                return 0;
            }

            return price.replace(/,/g, '');
        },
        BankNameBySheba(sheba) {
            if (sheba) {
                sheba = sheba.split('-').join('')
                sheba = sheba.split(' ').join('')
                sheba = sheba.split('_').join('')
                if (sheba.length >= 7)
                    sheba = sheba.slice(4, 7)
                else return;

                if (sheba == '010') {
                    return 'markazi'
                } else if (sheba == '011') {
                    return 'sanat-o-madan'
                } else if (sheba == '012') {
                    return 'mellat'
                } else if (sheba == '013') {
                    return 'refah'
                } else if (sheba == '014') {
                    return 'maskan'
                } else if (sheba == '015') {
                    return 'sepah'
                } else if (sheba == '016') {
                    return 'keshavarzi'
                } else if (sheba == '017') {
                    return 'melli'
                } else if (sheba == '018') {
                    return 'tejarat'
                } else if (sheba == '019') {
                    return 'saderat'
                } else if (sheba == '020') {
                    return 'tosee-saderat'
                } else if (sheba == '021') {
                    return 'post'
                } else if (sheba == '051') {
                    return 'tosee'
                } else if (sheba == '052') {
                    return 'ghavamin'
                } else if (sheba == '053') {
                    return 'karafarin'
                } else if (sheba == '054') {
                    return 'parsian'
                } else if (sheba == '055') {
                    return 'eghtesad-novin'
                } else if (sheba == '056') {
                    return 'saman'
                } else if (sheba == '057') {
                    return 'pasargad'
                } else if (sheba == '058') {
                    return 'sarmayeh'
                } else if (sheba == '059') {
                    return 'sina'
                } else if (sheba == '060') {
                    return 'mehr-iran'
                } else if (sheba == '061') {
                    return 'shahr'
                } else if (sheba == '062') {
                    return 'ayandeh'
                } else if (sheba == '063') {
                    return 'ansar'
                } else if (sheba == '064') {
                    return 'gardeshgari'
                } else if (sheba == '065') {
                    return 'hekmat-iranian'
                } else if (sheba == '066') {
                    return 'dey'
                } else if (sheba == '069') {
                    return 'iran-zamin'
                } else if (sheba == '070') {
                    return 'resalat'
                } else if (sheba == '090') {
                    return 'mehr-iran'
                } else if (sheba == '095') {
                    return 'iran-venezuela'
                }
            }
        },

        BankLogo(bank_name) {
            if (bank_name) {
                return require('../assets/media/banks-logos/' + bank_name + '.png')
            }
        },

        isShebaValid(str){
            if (str.length !== 26) {
                return false;
            }
            let pattern = /IR[0-9]{24}/;
            if (!pattern.test(str)) {
                return false;
            }
            let newStr = str.substr(4);
            let d1 = str.charCodeAt(0) - 65 + 10;
            let d2 = str.charCodeAt(1) - 65 + 10;
            newStr += d1.toString() + d2.toString() + str.substr(2, 2);

            let remainder = newStr,
                block;

            while (remainder.length > 2) {
                block = remainder.slice(0, 9);
                remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
            }
            let result = parseInt(remainder, 10) % 97;
            return result === 1;
        },

        pad(d) {
            return (d < 10) ? '0' + d.toString() : d.toString();
        },

        blankStr(value) {
            return (typeof value === 'undefined'
                || value === null
                || value === 'null'
                || value === ''
                || value.trim() === ''
                || value.length === 0
            );
        },

        filledStr(value) {
            return !this.blankStr(value);
        },

        blankArr(value) {
            return (typeof value === 'undefined'
                || value.length === 0
                || Object.keys(value).length === 0
            );
        },

        filledArr(value) {
            return !this.blankArr(value);
        },
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    }
}

export {Mixin};
export default {
    install(Vue, option) {
        Vue.mixin(Mixin)
    }
}
